export default "__VITE_ASSET__BdnARllr__"